import React from 'react';
import Head from 'next/head';
import Page from '../components/page';
import {SiteChrome, SiteData} from '../components/chrome/layout';
import CtaPanel from "../components/chrome/elements/panels/ctaPanel";
import GiveFeatures from "../components/chrome/elements/panels/giveFeatures";
import WhyMonthlyParent from "./../components/chrome/elements/panels/why-monthly";


import getConfig from 'next/config';
const config = getConfig().publicRuntimeConfig;

const daanUtsavData =  [
    {
        heading:'Lead the change to create a better world',
        subheading:'Start donating as little as Rs 500 per month to change someone\'s life',
        imgDesktop:`${config.cdnUrl}/static/images/home/du19/daan-utsav-main-bannner.jpg`,
        imgMobile: `${config.cdnUrl}/static/images/home/du19/daan-utsav-main-bannner-mobile.jpg`,
        isEven:true,
        desktopTextColor: '#444',
        mobileTextColor: '#444',
        lowerText: true,
        maxHeight: '190px'
    },
    {
        heading:' India houses the largest number of malnourished children in the world',
        subheading:'Midday meals not only provide children with nutrition but also help in breaking the cycle of poverty by keeping them in school and eradicating child labour',
        imgDesktop:`${config.cdnUrl}/static/images/home/du19/desktop-banner2-without-text.jpg`,
        imgMobile: `${config.cdnUrl}/static/images/home/du19/banner2-image.jpg`,
        mainCTAText:"give Rs. 500 monthly",
        mainCTALink: "https://www.giveindia.org/checkout?name=mission-10-million-meals&type=campaign&amount=500",
        secondaryCTAText:"Learn more",
        secondaryCTALink: "https://www.giveindia.org/campaign/mission-10-million-meals",
        isEven:false,
        desktopTextColor: '#ffffff',
        mobileTextColor: '#444'
    },
    {
        heading:'Rural women suffer from preventable complications during pregnancy',
        subheading:'Maternal healthcare centres in the remotest and backward areas of India can curb this crisis and help women have safer deliveries',
        imgDesktop:`${config.cdnUrl}/static/images/home/du19/banner3.png`,
        imgMobile: `${config.cdnUrl}/static/images/home/du19/banner3-image-new.jpg`,
        mainCTAText:"give Rs. 500 monthly",
        mainCTALink: "https://www.giveindia.org/checkout?name=Help-women-in-remote-villages-of-Odisha-get-access-to-maternal-health-care&type=program&amount=500",
        secondaryCTAText:"Learn more",
        secondaryCTALink: "https://www.giveindia.org/program/Help-women-in-remote-villages-of-Odisha-get-access-to-maternal-health-care",
        isEven:true,
        desktopTextColor: '#444',
        mobileTextColor: '#444'
    },
    {
        heading:'Every year over two million children suffer from preventable diseases',
        subheading:'Healthcare facilities and early intervention can prevent infant deaths and give our children a healthy future. Help India in making primary healthcare centres a must-have in even the remotest and most backward areas.',
        imgDesktop:`${config.cdnUrl}/static/images/home/du19/desktop-banner4-without-text.jpg`,
        imgMobile: `${config.cdnUrl}/static/images/home/du19/banner4-image.jpg`,
        mainCTAText:"give Rs. 500 monthly",
        mainCTALink: "https://www.giveindia.org/checkout?name=Support-the-treatment-of-a-baby-at-risk&type=program&amount=500",
        secondaryCTAText:"Learn more",
        secondaryCTALink: "https://www.giveindia.org/program/Support-the-treatment-of-a-baby-at-risk",
        isEven:false,
        desktopTextColor: '#444',
        mobileTextColor: '#444'
    },
    {
        heading:'Poor and abandoned elderly live a life stripped of dignity, love and basic amenities',
        subheading:'Your contribution can help them eat two nutritious meals a day, have a safe shelter and healthcare facilities',
        imgDesktop:`${config.cdnUrl}/static/images/home/du19/desktop-banner5-without-text.jpg`,
        imgMobile: `${config.cdnUrl}/static/images/home/du19/banner5-image.jpg`,
        mainCTAText:"give Rs. 1,155 monthly",
        mainCTALink: "https://www.giveindia.org/checkout?name=Sponsor-the-grocery-and-medical-care-for-poor-senior-citizens&type=program&amount=1155",
        secondaryCTAText:"Learn more",
        secondaryCTALink: "https://www.giveindia.org/program/Sponsor-the-grocery-and-medical-care-for-poor-senior-citizens",
        isEven:true,
        desktopTextColor: '#444',
        mobileTextColor: '#444'
    },
];

export default class extends Page {

    static async getInitialProps({ req, res }) {
        const props = await super.getInitialProps({ req, res });
        props.pageType = 'lead-change';

        return props;
    }

    render() {

        const panels = daanUtsavData.map(function (panelProps, idx) {
            return (<CtaPanel key={idx} {...panelProps} />)
        });

        const { session } = this.props;
        const store = { ... this.props.store };
        return (
            <SiteData store={store}>
                <SiteChrome session={session}>
                    <Head>
                        <title key="title">GiveIndia - Daan Utsav</title>
                    </Head>

                    {panels}

                    <WhyMonthlyParent/>
                    <GiveFeatures />


                </SiteChrome>
            </SiteData>
        );
    }
}
